import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { Modal as AntModal } from 'antd';
import { ModalFuncProps, ModalProps } from 'antd/es/modal';
import _ from 'lodash';
import styled from 'styled-components';
import * as styles from './modal.module.css';
import { Heading03 } from '../../styles';
import { ButtonStyle, TextButtonStyle } from '../button/button';
import { FontAwesomeIcon } from '../icon/icon';

const CloseIconWrapper = styled.div`
  width: var(--height-base);
  height: var(--height-base);
  ${ButtonStyle};
  ${TextButtonStyle};
`;

export const CloseIcon = () => (
  <CloseIconWrapper>
    <FontAwesomeIcon icon={faClose} />
  </CloseIconWrapper>
);
export const defaultModalProps: ModalFuncProps = {
  okButtonProps: { className: styles.ok_button, type: 'primary' },
  cancelButtonProps: { className: styles.cancel_button },
  closeIcon: <CloseIcon />,
};

// Dont use merge function, it is costly and introduces performance issues
export const Modal = styled(AntModal).attrs(
  (props: ModalProps & ModalFuncProps) => {
    _.set(
      props,
      'okButtonProps.className',
      `${styles.ok_button} ${props?.okButtonProps?.className}`,
    );
    if (!props?.okButtonProps?.type) {
      _.set(props as ModalFuncProps, 'okButtonProps.type', 'primary');
    }

    _.set(
      props,
      'cancelButtonProps.className',
      `${styles.cancel_button} ${props?.cancelButtonProps?.className}`,
    );

    if (!props?.closeIcon) {
      _.set(props, 'closeIcon', <CloseIcon />);
    }

    return props;
  },
)`
  .ant-modal-content {
    border-radius: var(--border-radius-small);
  }
  .ant-modal-header {
    border-radius: var(--border-radius-small);
    padding: var(--spacing-05) var(--spacing-06);
    border: none;

    .ant-modal-title {
      ${Heading03};
      width: calc(100% - var(--height-base));
    }
    border-bottom: 1px solid var(--divider-default);
  }
  .ant-modal-body {
    padding: var(--spacing-05) var(--spacing-06);
    width: 100%;
  }

  .ant-modal-footer {
    padding: var(--spacing-05) var(--spacing-06);
    border: none;
    border-top: 1px solid var(--divider-subtle);
  }
  .ant-modal-close-x {
    margin-top: 16px;
    margin-right: 24px;
    width: var(--height-base);
    height: var(--height-base);
  }
`;
